<ng-container *ngrxLet="routeData$ as routeData">
  <cigna-password-change-banner
    *ngIf="(showPasswordChangeWarning$ | async) && !routeData.disableNavigation"
    [lastChangedDate]="lastPasswordChangeDate$ | async"
  ></cigna-password-change-banner>

  <header role="banner" *ngrxLet="isResourcePage$ as isResourcePage">
    <cigna-header
      [firstName]="firstName$ | async"
      [lastName]="lastName$ | async"
      [userid]="userid$ | async"
      [profileLinks]="profileNav$ | async"
      [isImpersonator]="impersonator$ | async"
      [isNavigationDisabled]="routeData.disableNavigation"
      [isAuthenticated]="true"
      [logoLink]="
        routeData.disableNavigation && !isResourcePage
          ? ''
          : (logoLink$ | async)
      "
      [isLogoLinkInternal]="!isResourcePage"
      [isResourceResults]="isResourcePage"
      [hasMessageCenterFunction]="messageCenterFunction$ | async"
      [isOhpUser]="isOhpUser$ | async"
      (logOut)="shellFacade.logOut($event)"
    ></cigna-header>

    <cigna-primary-nav
      *ngIf="!routeData.disableNavigation"
      class="cg-hide-for-print"
      [links]="siteNav$ | async"
      [impersonator]="impersonator$ | async"
    ></cigna-primary-nav>
    <cigna-alerts
      *ngIf="(alert$ | async) && !routeData.disableNavigation"
      [alert]="alert$ | async"
    ></cigna-alerts>
  </header>

  <main role="main" [class.cg-padding-top-none]="(routeData$ | async)?.bluebar">
    <div [class.cg-inner-page-wrapper]="(routeData$ | async)?.bluebar !== true">
      <router-outlet></router-outlet>
    </div>
  </main>

  <cigna-footer-global
    [loggedIn]="true"
    [isMedical]="isMedicalUser$ | async"
  ></cigna-footer-global>
  <div class="chat-bubble-container" data-test-id="image-chat-bubble">
    <cigna-omni-entry></cigna-omni-entry>
  </div>

  <ng-container *ngIf="inBrowserPlatform">
    <cigna-timeout-popup></cigna-timeout-popup>
  </ng-container>

  <cigna-dev-toggle
    *ngIf="DEV_MODE"
    class="cg-hide-for-print"
  ></cigna-dev-toggle>
</ng-container>
